// Copyright (c) 2017 Deere & Company

import './customer-details.scss';
import * as customerService from '../../../product/shared/services/customer';
import React, {PropTypes} from 'react';
import {
    buildCityStateZip,
    buildCustomerAddress,
    buildEmailLink,
    buildPhoneNumber
} from '../../../product/shared/services/product';
import Customer from '@deere/cps-it.warranty-model-factory/lib/customer';
import {FormattedMessage} from 'react-intl';

function handleEditCustomer() {

    this.onEditCustomer();

}

const CustomerDetails = props =>
    <section className='customer-details'>
        <div className='name'>
            {customerService.customerDisplayText(props.customer)}
            <span
                className='edit-customer-link'
                onClick={props::handleEditCustomer}
            >
                <FormattedMessage id='EDIT_WITH_PARENTHESES'/>
            </span>
        </div>
        <div className='line1'>
            {buildCustomerAddress(props.customer).line1}
        </div>
        <div className='line2'>
            {buildCustomerAddress(props.customer).line2}
        </div>
        <div className='city-state-zip'>
            {buildCityStateZip(buildCustomerAddress(props.customer))}
        </div>
        <div className='country'>
            {buildCustomerAddress(props.customer).country}
        </div>
        {props.customer.phone.length > 0 &&
            <div className='phone'>
                {buildPhoneNumber(props.customer.phone[0])}
            </div>
        }
        <div className='email'>
            <a href={buildEmailLink(props.customer.email)}>
                {props.customer.email}
            </a>
        </div>
    </section>;

CustomerDetails.displayName = 'CustomerDetails';
CustomerDetails.propTypes = {
    customer: PropTypes.instanceOf(Customer).isRequired,
    onEditCustomer: PropTypes.func.isRequired
};

export default CustomerDetails;



// WEBPACK FOOTER //
// ./src/shared/components/customer-search-panel/customer-details.js